var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1068 3.48112L12.3265 3.70079H12.6371H19.6085C20.1492 3.70079 20.6677 3.91556 21.05 4.29786C21.4323 4.68017 21.6471 5.19868 21.6471 5.73934V14.105C21.6471 14.6457 21.4323 15.1642 21.05 15.5465C20.6677 15.9288 20.1492 16.1436 19.6085 16.1436H2.87718C2.33652 16.1436 1.818 15.9288 1.4357 15.5465C1.0534 15.1642 0.838623 14.6457 0.838623 14.105V2.95079C0.838623 2.41013 1.0534 1.89161 1.4357 1.50931C1.818 1.12701 2.33652 0.912231 2.87718 0.912231H9.5379L12.1068 3.48112Z",
    stroke: "#407DBB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2414 12.7108L14.03 9.92222M11.2414 7.13367V12.7108V7.13367ZM11.2414 12.7108L8.45288 9.92222L11.2414 12.7108Z",
    stroke: "#407DBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.db0fa4f9df3c2b7dd7a6de2e134640cb.svg";
export { ForwardRef as ReactComponent };